import styled from 'styled-components';
import Colors from 'assets/Colors';

const IconWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 42px;
  width: 42px;
  min-width: 42px;
  min-height: 42px;
  border-radius: 5px;

  ${(props) =>
    (props.selected
      ? `background: ${Colors.primary_web};`
      : `background: ${Colors.background_secondary}; `)}
`;

const ItemWrapper = styled.div`
  ${(props) =>
    (props.selected
      ? `background: ${Colors.background_secondary};  font-weight: 500;`
      : '')}
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-left: 18px;
  margin-right: 20px;
  margin-bottom: 13px;
  cursor: pointer;
  flex-direction: column;
`;

const TextWrapper = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  margin-top: 8px;
  text-align: center;
`;

export default {
  IconWrapper,
  ItemWrapper,
  TextWrapper,
};
